import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getSessionReview } from './api';

/** The key is per learner and attempt, so a second account on the same browser never sees the first's review. */
export const reviewKey = (userId: string | undefined, attemptId: string | undefined) => ['study-plan', 'review', userId, attemptId] as const;

/**
 * The end-of-session review of one finished attempt. Null data means there is none to
 * show (not graded yet, or the author hides results). No retry: a refused request is an
 * answer, and the results page must not wait on it.
 */
export function useSessionReview(attemptId: string | undefined, enabled = true) {
  const { state } = useAuthContext();
  const userId = state.user?.id;
  return useQuery({
    queryKey: reviewKey(userId, attemptId),
    queryFn: ({ signal }) => getSessionReview(attemptId!, signal),
    enabled: Boolean(userId && attemptId && enabled),
    retry: false,
    // A finished attempt does not change; a minute spares the server a dozen queries on every revisit.
    staleTime: 60_000,
  });
}
